<template>
    <page :showBackButton="true" ref="page">
        <contract-card :contractId="contractId"></contract-card>
        <expansion-card v-if="anpassenInfo !== ''">
            <template v-slot:header>
                <b>Wichtiger Hinweis</b>
            </template>
            <div v-html="anpassenInfo"></div>
        </expansion-card>
        <h2>Anpassen</h2>
        <form @submit.prevent="submitForm()">
            <stepper v-model="formstep" :count="stepCount">
                <stepper-item :step="1">
                    <b>Welchen Bereich möchtest du anpassen?</b>
                    <div>
                        <ion-button
                            expand="block"
                            class="ion-margin-top"
                            @click="changeFormstep(2)"
                            >Veranlagung neu aufteilen</ion-button
                        >
                        <ion-button
                            expand="block"
                            class="ion-margin-top"
                            @click="changeFormstep(3)"
                            >Nur Fonds neu aufteilen</ion-button
                        >
                        <ion-button
                            expand="block"
                            class="ion-margin-top"
                            @click="setup()"
                            >Zurücksetzen</ion-button
                        >
                    </div>
                </stepper-item>
                <stepper-item :step="2">
                    <h2>Veranlagung neu aufteilen</h2>
                    <ion-grid>
                        <ion-row>
                            <ion-col size="11">
                                <ion-row class="ion-align-items-center">
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                    <ion-col>
                                        Klassische Lebensversicherung
                                    </ion-col>
                                    <ion-col class="ion-text-center">
                                        {{ area }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <hr />
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        Fondsgebundene Lebensversicherung
                                    </ion-col>
                                    <ion-col class="ion-text-center">
                                        {{ 100 - area }}%
                                    </ion-col>
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                </ion-row>
                            </ion-col>
                            <ion-col size="1">
                                <vue-slider
                                    v-model="area"
                                    direction="ttb"
                                    height="100%"
                                    tooltip="none"
                                    :dotSize="24"
                                ></vue-slider>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button
                                    expand="block"
                                    @click="changeFormstep(3)"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item :step="3">
                    <h2>Fondskategorien neu aufteilen</h2>
                    <ion-grid>
                        <ion-row>
                            <ion-col size="11">
                                <ion-row class="ion-align-items-center">
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                    <ion-col>
                                        <b>Konservativ</b><br />
                                        Aktienanteil bis 40%
                                    </ion-col>
                                    <ion-col class="ion-text-center">
                                        {{ fondscategories[0] }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <hr />
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        <b>Ausgewogen</b><br />
                                        Aktienanteil bis 65%
                                    </ion-col>
                                    <ion-col class="ion-text-center">
                                        {{
                                            100 -
                                            fondscategories[0] -
                                            (100 - fondscategories[1])
                                        }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <hr />
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        <b>Dynamisch</b><br />
                                        Aktienanteil bis 100%
                                    </ion-col>
                                    <ion-col class="ion-text-center">
                                        {{ 100 - fondscategories[1] }}%
                                    </ion-col>
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                </ion-row>
                            </ion-col>
                            <ion-col size="1">
                                <vue-slider
                                    v-model="fondscategories"
                                    direction="ttb"
                                    height="100%"
                                    tooltip="none"
                                    :enableCross="false"
                                    :dotSize="24"
                                ></vue-slider>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button
                                    expand="block"
                                    @click="changeFormstep(4)"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item :step="4">
                    <h2>Fonds neu aufteilen</h2>
                    <div v-if="fondscategories[0] > 0">
                        <b>Konservativ</b><br />
                        Aktienanteil bis 40%
                        <ion-grid>
                            <ion-row>
                                <ion-col size="11">
                                    <ion-row class="ion-align-items-center">
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                        <ion-col>
                                            {{ flexiblelifeFonds1.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ conservative }}%
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                    <ion-row class="ion-align-items-center">
                                        <ion-col>
                                            {{ flexiblelifeFonds2.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ 100 - conservative }}%
                                        </ion-col>
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                </ion-col>
                                <ion-col size="1">
                                    <vue-slider
                                        v-model="conservative"
                                        direction="ttb"
                                        height="100%"
                                        tooltip="none"
                                        :dotSize="24"
                                    ></vue-slider>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                    <div v-if="fondscategories[0] !== fondscategories[1]">
                        <b>Ausgewogen</b><br />
                        Aktienanteil bis 65%
                        <ion-grid>
                            <ion-row>
                                <ion-col size="11">
                                    <ion-row class="ion-align-items-center">
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                        <ion-col>
                                            {{ flexiblelifeFonds7.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ balanced[0] }}%
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                    <ion-row class="ion-align-items-center">
                                        <ion-col>
                                            {{ flexiblelifeFonds3.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{
                                                100 -
                                                balanced[0] -
                                                (100 - balanced[1])
                                            }}%
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                    <ion-row class="ion-align-items-center">
                                        <ion-col>
                                            {{ flexiblelifeFonds4.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ 100 - balanced[1] }}%
                                        </ion-col>
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                </ion-col>
                                <ion-col size="1">
                                    <vue-slider
                                        v-model="balanced"
                                        direction="ttb"
                                        height="100%"
                                        tooltip="none"
                                        :enableCross="false"
                                        :dotSize="24"
                                    ></vue-slider>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                    <div v-if="fondscategories[1] < 100">
                        <b>Dynamisch</b><br />
                        Aktienanteil bis 100%
                        <ion-grid>
                            <ion-row>
                                <ion-col size="11">
                                    <ion-row class="ion-align-items-center">
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                        <ion-col>
                                            {{ flexiblelifeFonds5.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ dynamic }}%
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                    <ion-row class="ion-align-items-center">
                                        <ion-col>
                                            {{ flexiblelifeFonds6.name }}
                                        </ion-col>
                                        <ion-col class="ion-text-center">
                                            {{ 100 - dynamic }}%
                                        </ion-col>
                                        <ion-col size="12">
                                            <hr />
                                        </ion-col>
                                    </ion-row>
                                </ion-col>
                                <ion-col size="1">
                                    <vue-slider
                                        v-model="dynamic"
                                        direction="ttb"
                                        height="100%"
                                        tooltip="none"
                                        :dotSize="24"
                                    ></vue-slider>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button
                                    expand="block"
                                    @click="changeFormstep(5)"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item :step="5">
                    Möchtest du dein bisher angespartes Geld in die geänderte
                    Aufteilung übernehmen oder in den bisherigen Fonds belassen?
                    <ion-list>
                        <ion-radio-group>
                            <ion-item>
                                <ion-label text-wrap
                                    >Bisher geleistete Einzahlungen nicht
                                    übernehmen, nur die ab jetzt folgenden
                                    Zahlungen in die geänderte Fondsaufteilung
                                    einzahlen</ion-label
                                >
                                <base-radio
                                    self="switch"
                                    v-model="method"
                                ></base-radio>
                            </ion-item>
                            <ion-item>
                                <ion-label text-wrap
                                    >Bisherige und folgende Einzahlungen in die
                                    geänderte Aufteilung übernehmen</ion-label
                                >
                                <base-radio
                                    self="shift"
                                    v-model="method"
                                ></base-radio>
                            </ion-item>
                        </ion-radio-group>
                    </ion-list>
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button expand="block" @click="submitForm()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item :step="6">
                    <div v-html="risiko"></div>
                    Bitte bestätige, dass du den Hinweis auf die Risikoklasse
                    und die neue Fondsaufteilung gelesen hast und einverstanden
                    bist.
                    <ion-list>
                        <base-checkbox
                            v-model="agb1"
                            id="agb1"
                            label="Ich habe den Hinweis zur Risikoklasse gelesen und bin einverstanden."
                        ></base-checkbox>
                        <base-checkbox
                            v-model="agb2"
                            id="agb2"
                            label="Ich habe den Hinweis zur Fondsaufteilung gelesen und verstanden."
                        ></base-checkbox>
                    </ion-list>
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button
                                    expand="block"
                                    @click="changeFormstep(formstep + 1)"
                                    :disabled="!(agb1 && agb2)"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item :step="7">
                    <b>Du möchtest folgende Neuaufteilung vornehmen:</b>
                    <ion-card>
                        <ion-grid>
                            <ion-row class="ion-align-items-center">
                                <ion-col>
                                    Klassische Lebensversicherung
                                </ion-col>
                                <ion-col size="auto"> {{ area }}% </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card>
                        <ion-grid>
                            <ion-row class="ion-align-items-center">
                                <ion-col>
                                    Fondsgebundene Lebensversicherung
                                </ion-col>
                                <ion-col size="auto">
                                    {{ 100 - area }}%
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col size="12">
                                    <hr />
                                </ion-col>
                            </ion-row>
                            <div v-if="fondscategories[0] > 0">
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        <b>Konservativ</b> - Aktienanteil bis
                                        40%
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ fondscategories[0] }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds1.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ conservative }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds2.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ 100 - conservative }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                </ion-row>
                            </div>
                            <div
                                v-if="fondscategories[0] !== fondscategories[1]"
                            >
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        <b>Ausgewogen</b> - Aktienanteil bis 65%
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{
                                            100 -
                                            fondscategories[0] -
                                            (100 - fondscategories[1])
                                        }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds7.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ balanced[0] }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds3.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{
                                            100 -
                                            balanced[0] -
                                            (100 - balanced[1])
                                        }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds4.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ 100 - balanced[1] }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                </ion-row>
                            </div>
                            <div v-if="fondscategories[1] < 100">
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        <b>Dynamisch</b> - Aktienanteil bis 100%
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ 100 - fondscategories[1] }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds5.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ dynamic }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row class="ion-align-items-center">
                                    <ion-col>
                                        {{ flexiblelifeFonds6.name }}
                                    </ion-col>
                                    <ion-col size="auto">
                                        {{ 100 - dynamic }}%
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="12">
                                        <hr />
                                    </ion-col>
                                </ion-row>
                            </div>
                        </ion-grid>
                    </ion-card>
                    <!-- <div v-if="mtansend !== ''">
            Du erhältst in kürze eine SMS mit einer mobilen TAN an die Nummer {{ mtansend }}. Gib diese bitte in dem untenstehenden Feld ein.
            <base-input
              placeholder="mTAN"
              id="mtan"
              v-model="mtan"
              type="text"
            ></base-input>
          </div> -->
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-button expand="block" @click="stepBack()"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col>
                                <ion-button expand="block" @click="submitForm()"
                                    >Absenden</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
            </stepper>
        </form>
    </page>
</template>

<script>
import Page from "@/components/Page";
import ContractCard from "@/components/ContractCard";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { flexiblelife } from "@/mixins/flexiblelife";
import BaseRadio from "@/components/BaseRadio";
import BaseCheckbox from "@/components/BaseCheckbox";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import { changeFlexibleLife } from "@/api/flexiblelife";
import ExpansionCard from "@/components/ExpansionCard";
import MtanModal from "@/components/MtanModal";

export default {
    components: {
        Page,
        ContractCard,
        VueSlider,
        BaseRadio,
        BaseCheckbox,
        Stepper,
        StepperItem,
        ExpansionCard,
    },
    props: ["contractId"],
    mixins: [flexiblelife],
    data() {
        return {
            stepCount: 7,
            formstep: 1,
            prevFormstep: 1,
            area: 50,
            fondscategories: [33, 67],
            conservative: 50,
            balanced: [33, 67],
            dynamic: 50,
            method: "switch",
            agb1: false,
            agb2: false,
            risiko: "",
            // mtan: "",
            // mtansend: "",
            sendemail: false,
        };
    },
    mounted() {
        this.fillData();
        this.setup();
    },
    methods: {
        setup() {
            this.$store.cache
                .dispatch("flexiblelife/getFlexibleLife", this.contractId)
                .then(() => {
                    this.fillData();
                });
        },
        changeFormstep(nextStep) {
            this.$refs.page.scrollToTop();
            this.prevFormstep = this.formstep;
            if (this.formstep === 2 && this.area === 100) {
                this.formstep = this.formstep + 3;
            } else {
                this.formstep = nextStep;
            }
        },
        stepBack() {
            this.$refs.page.scrollToTop();
            if (this.prevFormstep < this.formstep) {
                this.changeFormstep(this.prevFormstep);
            } else {
                this.formstep--;
            }
        },
        submitForm(showSendemailInfo) {
            if (this.formstep === this.stepCount) {
                let message =
                    "Bitte bestätige, dass die neue Fondsverteilung wie gewünscht durchgeführt werden soll.";
                if (this.sendemail) {
                    let sendemailInfo = "";
                    if (showSendemailInfo) {
                        sendemailInfo =
                            "Diese Änderung kann nur von einem Berater vorgenommen werden. ";
                    }
                    message =
                        sendemailInfo +
                        "Bitte bestätige, dass die Neuaufteilung wie gewünscht an deinen Berater gesendet werden soll.";
                }
                this.$ionic.alertController
                    .create({
                        header: "Fondsverteilung anpassen",
                        message: message,
                        buttons: [
                            {
                                text: "Nein",
                                role: "cancel",
                            },
                            {
                                text: "Ja",
                                handler: () => {
                                    this.changeFlexibleLife();
                                },
                            },
                        ],
                    })
                    .then((a) => a.present());
            } else {
                if (this.formstep < this.stepCount - 1) {
                    this.risiko = "";
                    this.agb1 = false;
                    this.agb2 = false;
                    this.sendemail = false;
                    if (this.area === 100) {
                        this.agb1 = true;
                        this.agb2 = true;
                        // this.sendemail = true;
                    }
                }
                // if (this.formstep < this.stepCount) {
                //   this.mtansend = "";
                //   this.mtan = "";
                // }
                this.changeFlexibleLife();
            }
        },
        changeFlexibleLife(verifymtan = false, mtan = "") {
            var anteilKlassisch = this.area;
            var anteilFonds = 100 - anteilKlassisch;
            var calcamount40 = this.fondscategories[0];
            var calcamount65 =
                this.fondscategories[1] - this.fondscategories[0];
            var calcamount100 = 100 - this.fondscategories[1];
            var fond1percent = this.conservative;
            var fond2percent = 100 - fond1percent;
            var fond7percent = this.balanced[0];
            var fond3percent = this.balanced[1] - this.balanced[0];
            var fond4percent = 100 - this.balanced[1];
            var fond5percent = this.dynamic;
            var fond6percent = 100 - fond5percent;

            var data = {};
            data.vertragsnummer = this.contractId;
            data.klassischpercent = anteilKlassisch.toFixed(4);
            data.fonds1percent = (
                fond1percent *
                (calcamount40 / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds2percent = (
                ((fond2percent * calcamount40) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds7percent = (
                ((fond7percent * calcamount65) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds3percent = (
                ((fond3percent * calcamount65) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds4percent = (
                ((fond4percent * calcamount65) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds5percent = (
                ((fond5percent * calcamount100) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);
            data.fonds6percent = (
                ((fond6percent * calcamount100) / 100) *
                (anteilFonds / 100)
            ).toFixed(4);

            data.methode = this.method;
            data.simulate = false;
            data.agb1 = this.agb1;
            data.agb2 = this.agb2;
            data.risikochecked = false;
            data.verifymtan = verifymtan;
            data.mtan = mtan;
            data.sendemail = this.sendemail;
            if (this.formstep === this.stepCount) {
                data.risikochecked = true;
            }
            // if (this.formstep === this.stepCount) {
            //   data.verifymtan = true;
            // }

            this.$store.commit("setLoading", true);
            changeFlexibleLife(data).then((response) => {
                if (response.data.Status === 200) {
                    if ("mtansend" in response.data.Result) {
                        // this.mtansend = response.data.Result.mtansend;
                        // this.changeFormstep(this.stepCount);
                        this.$ionic.modalController
                            .create({
                                component: MtanModal,
                                backdropDismiss: false,
                                componentProps: {
                                    propsData: {
                                        mtansend: response.data.Result.mtansend,
                                        submitFunctionName:
                                            "changeFlexibleLife",
                                    },
                                    parent: this,
                                },
                            })
                            .then((m) => m.present());
                    } else {
                        let message =
                            "Die neue Fondsverteilung wird wie gewünscht durchgeführt.";
                        if (
                            this.sendemail &&
                            response.data.Result.emailsent &&
                            response.data.Result.emailsentberater
                        ) {
                            message =
                                "Die Neuaufteilung wurde wie gewünscht an deinen Berater gesendet. Du solltest in Kürze ein Bestätigungsmail erhalten.";
                        } else if (
                            this.sendemail &&
                            response.data.Result.emailsent
                        ) {
                            message =
                                "Du solltest in Kürze eine E-Mail mit den gewünschten Änderungen erhalten. Bitte setze dich mit Wüstenrot oder deinem persönlichen Makler in Verbindung, um die Änderungen durchzuführen.";
                        }
                        this.$ionic.modalController.dismiss();
                        this.$ionic.alertController
                            .create({
                                header: "mTAN Bestätigung",
                                message: message,
                                buttons: ["Ok"],
                            })
                            .then((a) => {
                                a.onDidDismiss().then(() => {
                                    this.$router.go(-1);
                                });
                                a.present();
                            });
                    }
                } else if (response.data.Status === 400) {
                    if ("risiko" in response.data.Errors) {
                        this.risiko = response.data.Errors.risiko;
                        if (Object.keys(response.data.Errors).length === 1) {
                            this.changeFormstep(this.formstep + 1);
                        }
                    } else if ("sendemail" in response.data.Errors) {
                        this.sendemail = true;
                        if (this.formstep === this.stepCount) {
                            this.submitForm(true);
                        } else if (
                            Object.keys(response.data.Errors).length === 1
                        ) {
                            this.changeFormstep(this.stepCount);
                        }
                    }
                }
            });
        },
        fillData() {
            // Veranlagung
            this.area = parseInt(this.flexiblelife.klvprozent) || 50;
            // Fondskategorien
            var overallshare40 = parseInt(this.fondsCategory40.prozent);
            var overallshare65 = parseInt(this.fondsCategory65.prozent);
            var overallshare100 = parseInt(
                100 -
                    (parseInt(this.flexiblelife.klvprozent) +
                        overallshare40 +
                        overallshare65)
            );
            var overallshare =
                overallshare40 + overallshare65 + overallshare100;
            var overallshare40relative = 33;
            var overallshare65relative = 34;
            if (overallshare !== 0 && !isNaN(overallshare)) {
                var overallshareFactor = 100 / overallshare;
                overallshare40relative = parseInt(
                    overallshare40 * overallshareFactor
                );
                overallshare65relative = parseInt(
                    overallshare65 * overallshareFactor
                );
            }
            this.fondscategories = [
                overallshare40relative,
                overallshare40relative + overallshare65relative,
            ];
            // Fonds
            var fond1 = parseInt(
                (parseInt(this.flexiblelifeFonds1.prozent) / overallshare40) *
                    100
            );
            var fond2_1 = parseInt(
                (parseInt(this.flexiblelifeFonds7.prozent) / overallshare65) *
                    100
            );
            var fond2_2 = parseInt(
                (parseInt(this.flexiblelifeFonds3.prozent) / overallshare65) *
                    100
            );
            var fond3 = parseInt(
                (parseInt(this.flexiblelifeFonds5.prozent) / overallshare100) *
                    100
            );
            this.conservative = fond1 || 50;
            this.balanced = [fond2_1 || 33, fond2_1 + fond2_2 || 67];
            this.dynamic = fond3 || 50;
        },
    },
    computed: {},
};
</script>

<style></style>
